// extracted by mini-css-extract-plugin
module.exports = {"normal":"layouts_normal__szPQ4","title":"layouts_title__3_j_J","logo":"layouts_logo__3P_Ct","header_title":"layouts_header_title__2Oxac"};